import React from 'react';
import RootLayoutSingleVoyage from "@containers/singleVoyage/views/layout/root/RootLayoutSingleVoyage";
import './styles/root.scss'
import ContentLayoutSingleVoyage from "@containers/singleVoyage/views/layout/contentVoyage/ContentLayoutSingleVoyage";

import SecondarySidebarMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/views/secondarySidebar/SecondarySidebarMutateSingleVoyage";
import RootSidebarMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/views/rootSidebar/RootSidebarMutateSingleVoyage";
import TopSidebarMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/views/topSidebar/TopSidebarMutateSingleVoyage";
import MapWithInitialCenterMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/map/MapWithInitialCenterMutateSingleVoyage";


const RootMutateSingleVoyage = () => {
    return (
        <RootLayoutSingleVoyage>

            <TopSidebarMutateSingleVoyage/>

            <ContentLayoutSingleVoyage>

                <RootSidebarMutateSingleVoyage/>

                <MapWithInitialCenterMutateSingleVoyage/>

                <SecondarySidebarMutateSingleVoyage/>
            </ContentLayoutSingleVoyage>

        </RootLayoutSingleVoyage>
    );
};

export default RootMutateSingleVoyage;